/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner
 */
export interface ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner {
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner
   */
  uuid?: string;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner
   */
  tubeNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner
   */
  tubeStatus?: string | null;
}

/**
 * Check if a given object implements the ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner interface.
 */
export function instanceOfApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner(
  value: object
): value is ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner {
  return true;
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner {
  return ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    tubeNumber:
      json["tube_number"] === undefined
        ? undefined
        : json["tube_number"] === null
        ? null
        : json["tube_number"],
    tubeStatus:
      json["tube_status"] === undefined
        ? undefined
        : json["tube_status"] === null
        ? null
        : json["tube_status"],
  };
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner {
  return ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInnerToJSONTyped(
  value?: ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesTubesInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    uuid: value["uuid"],
    tube_number: value["tubeNumber"],
    tube_status: value["tubeStatus"],
  };
}
